import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saves, setSaves] = useState([]);

  const refreshSaves = useCallback(async () => {
    try { const r = await api.get("/me/saves"); setSaves(Array.isArray(r.data) ? r.data : []); } catch (e) { setSaves([]); }
  }, []);

  const check = useCallback(async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); } catch (e) { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => {
    // Skip /me while returning from OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    check();
  }, [check]);

  useEffect(() => {
    if (user) refreshSaves(); else setSaves([]);
  }, [user, refreshSaves]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + window.location.pathname;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(null);
  };

  const isSaved = (kind, slug) => saves.some((s) => s.kind === kind && s.slug === slug);
  const toggleSave = async (kind, slug) => {
    if (!user) return login();
    await api.post("/me/saves", { kind, slug });
    refreshSaves();
  };

  return (
    <Ctx.Provider value={{ user, setUser, loading, login, logout, saves, isSaved, toggleSave }}>
      {children}
    </Ctx.Provider>
  );
}
